<template>
  <div class="famous" style="background: #f3f3f3">
    <div class="assreboxo">
      <div class="assret">当前位置：<span>会员风采</span>&nbsp;>&nbsp;<span>明星企业</span></div>
    </div>
    <div class="asmbox">
      <div class="assle">
        <div class="assltt">
              <el-collapse v-for="(item,index) in menuList" :key="index" >
                <div @click.stop="switchMenu(item)">
                  <el-collapse-item :title="item.name" :name="item.id" >
                    <div class="sfqitem active" v-for="(items,indexs) in item.subCates" :key="indexs" style="display:block" @click.stop="switchMenus(items.name)">
                      <router-link :to="navUrl" class="" style="color: #fff" target="_blank"> {{items.name}} </router-link>
                    </div>
                  </el-collapse-item>
                </div>
              </el-collapse>

        </div>
      </div>
      <div class="assre">
        <div class="assrebox">
          <div class="assreboxt"></div>
          <div class="conulbox">
            <ul>
              <li v-for="item in newList" v-bind:key="item.id" @click="handlelitxq(item.id)">
                <div style="display: flex">
                  <!-- <div :class="item.istop ? 'litit1 one-line' : 'litit one-line'" v-html="item.title"></div> -->
                  <div class="litit one-line">
                    <img src="../assets/image/wzzd.png" style="width: 12px" alt="" v-if="item.istop" />
                    <span>{{ item.title }}</span>
                  </div>
                  <!-- <div class="zdspan" v-if="item.istop">置顶</div> -->
                  <div class="wztime">{{ item.createTime }}</div>
                </div>
                <div class="licont two-line" v-if="item.summary">{{ item.summary }}</div>
                <div class="licont two-line" v-else>{{ item.content | ellipsis }}</div>
              </li>
            </ul>
          </div>

          <div class="seablym">
            <!--@size-change=  pageSize 改变时会触发 -->
            <!-- @current-change=  currentPage 改变时会触发 -->
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="form.page"
              :page-size="15"
              layout="prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
          <div class="seabxxfy">
            <el-pagination
              small
              layout="prev, pager, next"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="form.page"
              :page-size="15"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment/moment';
import { news, getMenus } from '@/api/index.js';
import { $fmtTime } from '@/utils/utils.js';
export default {
  name: 'famous',
  filters: {
    ellipsis(value) {
      // 正则去除html标签
      if (value.match(/[\u4e00-\u9fa5]/g)) {
        value = value.match(/[\u4e00-\u9fa5]/g).join('');
      } else {
        return;
      }
      // 不为空将显示字数小于90个
      if (value.length > 100) {
        return value.slice(0, 100) + '...';
      }
      return value;
    },
    ellipsisss(value) {
      // 正则去除html标签
      value = value.replace(/<[^>]+>/g, '');
      // 判断是否为空
      if (!value) return '';
      // 不为空将显示字数小于90个
      if (value.length > 42) {
        return value.slice(0, 42) + '...';
      }
      return value;
    }
  },
  data() {
    return {
      form: {
        siteid: 2,
        cateid: 5000,
        online: 1,
        enabled: 1,
        page: 1,
        limit: 15
      },
      newList: [],
      total: 0, //总页数
      urlname: this.$route.path,
      title: document.title,
      activelist: 6,
      menuList:'',//侧边栏列表
      navUrl:'',
      activeNames:'',
    };
  },
  computed: {
    time() {
      return $fmtTime;
    }
  },

  //声明传递过来的子组件
  components: {},
  created() {
    this.getList();
    this.getMenu()
  },
  mounted() {
  },
  methods: {
    getList() {
      news(this.form).then(res => {
        console.log(res);
        this.newList = res.data.data.records;
        this.total = res.data.data.total;
        this.newList.forEach(item => {
          item.createTime = moment(item.createTime).format('YYYY-MM-DD');
        });
      });
    },
    getMenu() {
      getMenus({siteId:2}).then((res) => {
        this.menuList = res.data.data
      })
    },
    //一级菜单路径
    switchMenu(e) {
      switch(e.name) {
          case '通知公告':
            this.navUrl = '#/softoa'
            break;
          case '协会服务':
            this.navUrl = '#/asoser';
            break;
          case '协会快讯':
            this.navUrl = '#/assnew';
            break;
          case '党建动态':
            this.navUrl = '#/concen';
            break;
          case '关于协会':
            this.navUrl = '#/associ';
            break;
      }
      if(e.subCates.length == 0) {
        window.open(this.navUrl,'_blank')
      }else {
        console.log(111);
      }
    },
    // 二级菜单路径
    switchMenus(e) {
      switch(e) {
          case '明星企业':
            this.navUrl = '/famous';
            break;
          case '人物风采':
            this.navUrl = '/character';
            break;
          case '优质产品':
            this.navUrl = '/products';
            break;
      }
    },
    handlelitxq(id) {
      let url = this.$router.resolve({ path: 'notann', query: { id: id, url: this.urlname, title: this.title } });
      window.open(url.href,'_blank')
    },
    handleSizeChange(val) {
      this.form.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.getList();
    }
  }
};
</script>
<style lang="stylus" scoped>
.assreboxo
    width:100%;
    margin:0 auto;
    font-family: PingFang SC-Regular
    font-size: 16px;
    // background: #fff
    padding:15px;
    // @media screen and (max-width:800px) {
    //   display: none;
    // }
    .assreboxo
    >span
      color: #1a1a1a
      cursor: pointer;

.litit1
  color: #346CC6
  font-weight: bold
.wztime
  float: right
  font-size 12px
.licont1
  margin: 13px 0
  font-size:15px
  color: #af0505
a
  text-decoration: none
.asmbox
  max-width: 1200px
  margin: 0 auto
  display: flex
 .assle
  background: #fff !important;
  // width: 258px !important;

  // .assltt
  //   width: 100%
  //   .assltt
  //   >ul>li
  //     color: #7A7A7A
  //     width: 79%
  //     font-family: Microsoft YaHei
  //     margin:5px 0 5px 20px
  //   .assltt
  //   >ul>li>a
            // color: #7A7A7A

    .assre
        width: 80%;
        // min-width: 535px;
        background: #fff;
        .assrebox
          margin:0 20px
          .assreboxo
            margin-top: 20px
            margin-top: 20px
            .assreboxo
            >span
              color: #346CC6
    .conulbox
      margin-bottom:30px
    .conulbox >ul >li
      font-size 14px
      margin:15px 15px 10px 15px
      border-bottom: 1px dashed #C1C1C1;
    .conulbox >ul >li
      color:#7a7a7a
    .litit
      color: #000
    .litit >span
      // float: right
      font-size 12px
    .licont
      margin: 13px 0
      font-size:15px

  .seablym
    margin: 50px 80px 50px 60px
    color: #525252
  .seablym>span
    border: 1px solid #C4C4C4
    padding: 5px 13px
    font-size:13px
  .clkcor
    color: #fff
    background: #4088FF
    border: 0
  .fistsp
    color: #C4C4C4
    margin-left: 13px
  .clkinp
    margin: 0 5px
  .clkinp >input
    width: 22px
    height: 20px
    border: 0
    outline: none;

.seasj
  text-align: center
  color: #525252;
  margin-bottom: 15px
  display: none
.seasj>span
  border: 1px solid #c4c4c4;
  padding: 5px 13px;
  font-size: 13px;

.assreboxo >span >a
  color: #346cc6;
  text-decoration: none

@media screen and (max-width:800px)
  .Assmem
    background:#fff
  .asmbox
    display: block
  .assle
    display: none
  .assre
    background: #fff
    .assrebox
      margin: 0
  .seasj
    display: block

/deep/.el-icon-arrow-right {
  display: none;
}
.sfqitem {
  height: 49px;
  line-height: 49px;
  // padding-left: 45px;
  font-size: 16px;
  color: #303133;
}
.sfqitem:hover {
  cursor:pointer;
  // padding-left: 0px;
  background-color #fff;
}
</style>
